import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HabitIncrementResponse, HabitTargetResponse, IncrementHabitRequest, SetHabitTargetRequest } from './habit.model';

/**
 * Service for managing habits related to today's activities.
 *
 * This service provides methods to increment habit counts for specific activity types on a given day.
 *
 * @author sadatmalik
 */
@Injectable({ providedIn: 'root' })
export class HabitService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/habits`;

  increment(activityTypeId: string, request: IncrementHabitRequest): Observable<HabitIncrementResponse> {
    return this.http.post<HabitIncrementResponse>(`${this.baseUrl}/${activityTypeId}/increment`, request);
  }

  setTarget(activityTypeId: string, request: SetHabitTargetRequest): Observable<HabitTargetResponse> {
    return this.http.put<HabitTargetResponse>(`${this.baseUrl}/${activityTypeId}/target`, request);
  }
}
